module.exports = __webpack_public_path__ + "img/1.a482fd51.jpg";